import { format } from "date-fns";
import { uk } from "date-fns/locale";

import { capitalizeFirstLetter } from "./capitalize";

export type TDate = string | number | Date | undefined | null;

export const dateToReadable = (date: TDate, capitalize = false) => {
  if (!date) return null;

  const formattedDate = format(new Date(date), "EEEE, dd.MM.yyyy", {
    locale: uk,
  });

  if (capitalize) {
    return capitalizeFirstLetter(formattedDate);
  }
  return formattedDate;
};

export const dateToReadableDMY = (date: TDate) => {
  if (!date) return null;
  return format(date, "d, MMM yyyy", { locale: uk });
};

export const dateToDDMM = (date: TDate) => {
  if (!date) return null;

  const formattedDate = format(new Date(date), "dd.MM", {
    locale: uk,
  });

  return formattedDate;
};

export const dateToDDMMYY = (date: TDate) => {
  if (!date) return null;

  const formattedDate = format(new Date(date), "dd.MM.yy", {
    locale: uk,
  });

  return formattedDate;
};

export const dateToReadableDMYTime = (date: TDate) => {
  if (!date) return null;

  const formattedDate = format(new Date(date), "dd.MM.yyyy  HH:mm", {
    locale: uk,
  });

  return formattedDate;
};

export const toReadableDay = (date: TDate) => {
  if (!date) {
    return "";
  }
  const dayNames = ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
  const dayIndex = Number(format(date, "i"));
  return dayNames[dayIndex % 7];
};

export const toReadableWeek = (date: TDate) => {
  if (!date) {
    return "";
  }
  return format(date, "dd.MM", { locale: uk });
};

export const toReadableMonth = (date: TDate) => {
  if (!date) {
    return "";
  }
  return format(date, "LLL", { locale: uk });
};

type GroupBy = "day" | "week" | "month";

export const dateToReadableByGrouBy = (date: TDate, type: GroupBy) => {
  switch (type) {
    case "day":
      return toReadableDay(date);
    case "month":
      return toReadableMonth(date);
    default:
      return toReadableWeek(date);
  }
};
